import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { first} from 'rxjs/operators';
import { DataEnvService } from '../../shared/sl-data/data-env.service';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import DataSource from 'devextreme/data/data_source';
import { ModalServiceN } from 'src/app/shared/modal/modal.service';
import { OrderData } from 'src/app/shared/sl-data/order';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Job, JobDatService } from 'src/app/shared/sl-data/job';
import { EditOrderComponent } from 'src/app/shared/sl-components/edit-order/edit-order.component';
import { SlPlanningService } from 'src/app/shared/sl-planning/sl-planning.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-orders-grid',
  templateUrl: './orders-grid.component.html',
  styleUrls: ['./orders-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrdersGridComponent implements OnInit {
  jobsSource: any = {};
  dataSource: any = {};
  selectedStartDate: Date = new Date();
  selectedEndDate: Date = new Date();
  dataIsChanging: boolean = false;
  public featureFlags$ = this.dataEnv.featureFlags$;
  public requestInProg$ = new BehaviorSubject(false);

  async onRowClick(e: any) {
    const fflags: any = await firstValueFrom(this.featureFlags$);
    if(!fflags?.editOrder){
      return;
    }
    const job = await firstValueFrom<Job>(this.jobData.getJob$(e.data.docId));
    this.modalCtrl.show(EditOrderComponent, { order: await this.orderData.orderFromJob(job) });
  }

  createNewOrder() {
    this.modalCtrl.show(EditOrderComponent, { order: {} });
  }

  constructor(
    private fns: AngularFireFunctions,
    private dataEnv: DataEnvService,
    private modalCtrl: ModalServiceN,
    private orderData: OrderData,
    private jobData: JobDatService,
    private planning: SlPlanningService,
    private utilities:UtilitiesService
  ) {

    const currentInstance = this;

    this.jobsSource = new CustomStore({
      key: "docId",
      load: async function (loadOptions: any) {

        //const skip = loadOptions.skip ? loadOptions.skip : 0;
        //const take = loadOptions.take ? loadOptions.take : 0;
        const dateStart = currentInstance.selectedStartDate.toISOString().split('T')[0];
        const dateEnd = currentInstance.selectedEndDate.toISOString().split('T')[0];

        const selectedHub = await currentInstance.dataEnv.selectedHub$.pipe(first()).toPromise() || '';
        const callable = fns.httpsCallable(`queryJobsList/${dateStart}/${dateEnd}/${selectedHub}`);
        return callable({}).toPromise().then((data: any) => {

          data.forEach(job => {
            job.scheduledDate = job.scheduling.itinerary.date;
            const uniqueJobDetailIds = new Set();
            job.itemsCount = job.items.reduce((count, item) => {
                if (!uniqueJobDetailIds.has(item.jobDetailId)) {
                    uniqueJobDetailIds.add(item.jobDetailId);
                    const quantity = item.subItems?.length > 0 ? item.subItems[0].quantity || 1 : 1;
                    return count + quantity;
                }
                return count;
            }, 0);
            job.customerName = job.customer.firstName + ' ' + job.customer.lastName;
          });

          return {
            data: data,

          };
        });
      }
    });

    this.dataSource = new DataSource({
      store: this.jobsSource
    });

  }

  public yesterdayClickHandler() {
    this.dataIsChanging = true;
    const newDate = moment().add(-1, 'days').toDate();
    this.selectedStartDate = newDate;
    this.selectedEndDate = newDate;
    this.dataIsChanging = false;
    this.dataSource.reload();
  }

  public todayClickHandler() {
    this.dataIsChanging = true;
    const newDate = moment().toDate();
    this.selectedStartDate = newDate;
    this.selectedEndDate = newDate;
    this.dataIsChanging = false;
    this.dataSource.reload();
  }

  public tomorrowClickHandler() {
    this.dataIsChanging = true;
    const newDate = moment().add(1, 'days').toDate();
    this.selectedStartDate = newDate;
    this.selectedEndDate = newDate;
    this.dataIsChanging = false;
    this.dataSource.reload();
  }

  public dateChangedStart(e) {
    if (this.dataIsChanging)
      return;
    this.selectedStartDate = e.value;
    this.dataSource.reload();
  }

  public dateChangedEnd(e) {
    if (this.dataIsChanging)
      return;
    this.selectedEndDate = e.value;
    this.dataSource.reload();
  }

  async ngOnInit() {
    await this.dataEnv.setComFromCurrentUser();
  }

  public async editOrder(orderId: number) {
    const fflags: any = await firstValueFrom(this.featureFlags$);
    if(!fflags?.editOrder){
      return;
    }
    console.log(orderId);
    this.modalCtrl.show(EditOrderComponent, { order: await this.orderData.orderFromId(orderId) });
  }

  public async deleteOrder(orderId: number) {
    const fflags: any = await firstValueFrom(this.featureFlags$);
    if(!fflags?.editOrder){
      return;
    }
    try{
      this.requestInProg$.next(true);
      await this.planning.deleteOrder(orderId);
      this.dataSource.reload();
      this.utilities.notifySuccess('Order deleted successfully.');
    }
    catch(err){
        if(err.details){
            this.utilities.notifyError(err.details);
            return;
        }
        this.utilities.notifyError('Unexpected error deleting orders. Please contact system admin');
    }
    finally{
      this.requestInProg$.next(false);
    }
  }


}

/*
Possible filters:
Date
Status



*/





